import {
    lastDossierEmptyStyle,
    lastDossierMetaStyle,
    lastDossierPanelStyle,
    lastDossierPointStyle,
    lastDossierPointsStyle,
} from "../classicStyles";
import { CHARTER_COLORS as theme } from "../../shared/controleTheme";
import { PATIENT_CONTROL_POINTS, VARIANT } from "../classicVariant";
import { formatDate, formatDateTime, formatPatientName } from "../../shared/controleFormat";
import { controlPointLabel, launchStatusLabel } from "../../shared/controleVariants";
import { normalizePatientPointState } from "../../shared/patientControlRules";
import { controleModalOverlayStyle, controleModalStyle, modalCloseButtonStyle } from "../../shared/styles/layoutStyles";
import { lastDossierStatusStyle } from "../../shared/styles/patientStyles";
import ModalBackdrop from "../../../../components/ModalBackdrop";

export function renderLastDossierPatientModal(view) {
    const { activeControleMode, lastDossierPatientModal, setLastDossierPatientModal } = view;
    if (!lastDossierPatientModal) return null;
    const { patient, dossier, controls } = lastDossierPatientModal;
    const launchState = normalizePatientPointState(controls?.tracageLogiciels);
    return (
        <div style={controleModalOverlayStyle}>
            <ModalBackdrop onClose={() => setLastDossierPatientModal(null)} />
            <div role="dialog" aria-modal="true" aria-labelledby="last-dossier-title" style={{ ...controleModalStyle, maxWidth: "820px", position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                    <div style={{ minWidth: 0 }}>
                        <h2 id="last-dossier-title" style={{ margin: 0, color: theme.ink, fontSize: "18px", fontWeight: 950 }}>
                            Dernier dossier de lot
                        </h2>
                        <p style={{ margin: "6px 0 0", color: theme.muted, fontSize: "13px", overflowWrap: "anywhere" }}>
                            {formatPatientName(patient)}
                        </p>
                    </div>
                    <button type="button" onClick={() => setLastDossierPatientModal(null)} style={modalCloseButtonStyle}>×</button>
                </div>
                {!dossier ? (
                    <div style={lastDossierEmptyStyle}>
                        Aucun ancien dossier de lot avec contrôle patient enregistré pour ce patient.
                    </div>
                ) : (
                    <div style={lastDossierPanelStyle}>
                        <div style={lastDossierMetaStyle}>
                            <span><strong>Dossier</strong> {dossier.numeroLot || "—"}</span>
                            <span><strong>Date production</strong> {formatDate(dossier.dateProduction)}</span>
                            <span><strong>Statut lancement</strong> {launchStatusLabel(VARIANT, launchState.launchStatus || "PAS_LANCE")}</span>
                            {launchState.launchStatusAt && <span><strong>Lancé le</strong> {formatDateTime(launchState.launchStatusAt)}</span>}
                            {launchState.launchStatusBy && <span><strong>Par</strong> {launchState.launchStatusBy}</span>}
                        </div>
                        <div style={lastDossierPointsStyle}>
                            {PATIENT_CONTROL_POINTS.map(([pointKey, label], index) => {
                                const state = normalizePatientPointState(controls?.[pointKey]);
                                return (
                                    <div key={pointKey} style={lastDossierPointStyle(state.validated)}>
                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", flexWrap: "wrap" }}>
                                            <strong style={{ color: theme.ink, fontSize: "13px" }}>
                                                Point {index + 2} · {controlPointLabel(VARIANT, "avantLancement", pointKey, label, activeControleMode)}
                                            </strong>
                                            <span style={lastDossierStatusStyle(state.validated)}>
                                                {state.validated ? "Validé" : "Non validé"}
                                            </span>
                                        </div>
                                        <div style={{ color: theme.muted, fontSize: "13px", lineHeight: 1.45, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                                            {state.comment?.trim() || "Aucun commentaire."}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
